export default __webpack_public_path__ + "static/media/days&dates.cfe1e63a.svg";